import { render, staticRenderFns } from "./VDeadlineColor.vue?vue&type=template&id=3459c720&"
import script from "./VDeadlineColor.vue?vue&type=script&lang=js&"
export * from "./VDeadlineColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports